import {AbstractModel} from './abstract-model';

export class PageType extends AbstractModel {

  id: number | null = null;
  name: string | null = null;

  override toString(): string {
    return this.name ?? '';
  }

}
